import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { IMouseDown, IMouseMove, IMouseRelease, IDoubleClick } from '../Interfaces';
import { DrawingsHolderService } from '../drawings-holder.service';
import { PositionCalculatorService } from '../position-calculator.service';
import { Dimensions } from '../object3D';
import { DimensionsEditorComponent } from '../ng-components/dimensions-editor/dimensions-editor.component';
import { MatDialog } from '@angular/material';
import { ArrowHolder } from '../object3D/Dimensions/ArrowHolder';
import { Size } from '../object3D/Dimensions/Size';
import { SelectComponent } from '.';
declare let THREE: any;

export class info {
  text: string;
  needArrow: boolean;
  changed: boolean;
}

@Injectable()
export class DrawDimensionsComponent extends ComponentBase
  implements IMouseMove, IMouseDown, IMouseRelease, IDoubleClick {
  dblclick(e: MouseEvent): boolean {

    this.selectComponent.enable();
    this.selectComponent.mouseUp(e);
    this.disable();
    return true;
  }

  private firstPoint;
  private object: Dimensions | undefined;
  private lastMousePosition: { x: number, y: number } = { x: 0, y: 0 };
  public TextScale = 1;
  length: any;

  constructor(
    private dialog: MatDialog,
    private drawings: DrawingsHolderService,
    private positionCalculator: PositionCalculatorService,
    private selectComponent: SelectComponent
  ) {
    super();
    this.disable();
  }

  private snapPointToSaveNeededAngle(point) {
    const lineLength = this.firstPoint.distanceTo(point);
    let finalPoint = this.firstPoint.clone();
    for (let i = 0; i < 24; i++) {
      const angle = Math.PI / 12 * i;
      const pPoint = new THREE.Vector3(Math.cos(angle), 0, Math.sin(angle));
      pPoint.setLength(lineLength);
      pPoint.add(this.firstPoint);
      if (point.distanceTo(pPoint) < point.distanceTo(finalPoint)) {
        finalPoint = pPoint;
      }
    }
    return finalPoint;
  }

  mouseDown(e: MouseEvent): boolean {
    // if (!this.firstPoint) {
    //   const point = this.positionCalculator.calculate(e);
    //   this.object = new Dimensions();
    //   this.object.position.copy(point);
    //   this.drawings.canvas.add(this.object);
    //   this.firstPoint = point;
    //   this.lastMousePosition.x = e.offsetX;
    //   this.lastMousePosition.y = e.offsetY;
    //   this.length = 0;
    //   return true;
    // }
    return false;
  }

  mouseMove(e: MouseEvent): boolean {
    if (this.firstPoint) {
      let position = this.positionCalculator.calculate(e);
      const currentAngle = Math.atan((position.z - this.firstPoint.z) / (position.x - this.firstPoint.x));

      if (!e.shiftKey && (currentAngle % Math.PI / 12 !== 0)) {
        position = this.snapPointToSaveNeededAngle(position);
      }

      this.object.update(this.firstPoint, position);
      this.length = this.firstPoint.distanceTo(position);
      return true;
    }
    return false;
  }

  mouseUp(e: MouseEvent): boolean {
    console.log('e', e);
    if (this.firstPoint) {
      if (e.offsetY === this.lastMousePosition.y && e.offsetX === this.lastMousePosition.x) {
        this.drawings.canvas.remove(this.object);
      }
      this.firstPoint = null;
      const size = this.object.children.filter(ch => ch instanceof Size)[0];

      this.object.Length = this.length;

      return true;
    } else {
      const point = this.positionCalculator.calculate(e);
      this.object = new Dimensions();
      this.object.modifiedAtStep3 = true;

      let LabelDim = this.object.children.filter(ch => ch.name === "LabelDim")[0];
      let Label = this.object.children.filter(ch => ch.name === "Label")[0];
      LabelDim.scaleCor = this.TextScale;
      Label.scaleCor = this.TextScale;
      this.object.position.copy(point);
      this.drawings.canvas.add(this.object);
      this.firstPoint = point;
      this.lastMousePosition.x = e.offsetX;
      this.lastMousePosition.y = e.offsetY;
      this.length = 0;
      return true;
    }
    // return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/DrawDimensionsComponent.ts